import { ReactComponent as Play } from './images/play-button.svg';

export const PlayIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <Play {...props} />
);